import { postAnalyticsEvent } from '@/model/analytics/analytics.model';
import { logger } from '@/shared/helpers/logger';
import { useStateReader } from '@/shared/hooks/useStore';
import { useCallback } from 'react';

interface TokenState {
  readonly userData: { readonly apiToken: string | null };
}

const selectApiToken = (state: TokenState): string | null => state.userData.apiToken;

export function useAnalyticsTransport(): (
  endpoint: string,
  body: Record<string, unknown>,
) => Promise<void> {
  const readToken = useStateReader(selectApiToken);

  const trackWithBackend = useCallback(
    async (endpoint: string, body: Record<string, unknown>) => {
      const token = readToken();
      if (!token) return;

      try {
        await postAnalyticsEvent(token, endpoint, body);
      } catch (error) {
        logger.error('[Analytics] Failed to track event with backend', {
          log_source: 'useAnalyticsTracker',
          endpoint,
          error,
        });
      }
    },
    [readToken],
  );

  return trackWithBackend;
}
